<template>
  <div class = "headers">
      <div class = 'logoNavBox' >
        <img class = 'logoImg' src="../../../static/images/logo.svg" alt="">
        <div class="navBox">
          <router-link class='navItem'  :to="item.path" v-for = '(item,index) in navList' :key = 'index' >{{ item.value}}</router-link>
        </div>
      </div>

      <div class = 'seachBox' v-if = 'seachflag'>
        <div class = 'seachName'>产品搜索</div>
        <input class = 'seachInput' type="text" placeholder="请输入要查询的产品" @keyup.enter="handleclickseach" v-model="seachInput"> 
        <div class = 'seachImg' @click = 'handleclickseach'>
          <img class = 'seachhome' src="../../../static/images/homeseach.svg" alt="">
        </div>
      </div>

      
      <div class = 'userBox' v-if = 'userName'>
        <div class = 'usernameBox' >{{ userName }}</div>
        <div class = 'logoutBox' @click = 'handleClickout'>退出</div>
      </div>
      <div class = 'logregbox' v-else>
        <div class= 'login'  @click = 'handleClickLogin'>登录</div>
        <div class='resg'  @click = 'hanldeClickRegister'>注册</div>
      </div>
      <login :dialogFlag = "dialogFormVisible" :titleFlag = 'titleFlag' @close="close"></login>

  </div>
</template>



<script>
import { setCookie,getCookie } from '../../../static/js/cookie.js'

import login from "../login/login.vue"

export default {
  components: {
    login
  },
  computed: {
    seachflag(){
      return this.$store.state.seachflag
    }
  },
  data () {
    return {
      seachInput:'',
      userName:'',
      dialogFlag:true,
        titleFlag:'0',
        dialogFormVisible:false,
        dialogFormVisible1:false,
        navList:[
          {
            value:'首页',
            path:'homePage'
          },
          {
            value:'产品查询',
            path:'productSeach'
          },
          {
            value:'特征指标查询',
            path:'indicatorSeach'
          },
          {
            value:'科普交流',
            path:'psCommunication'
          },
          {
            value:'风险管控',
            path:'riskControl'
          },
          {
            value:'新闻动态',
            path:'news'
          },
          {
            value:'产业服务',
            path:'industrialServices'
          },
          {
            value:'关于我们',
            path:'aboutAs'
          }
        ]
    };
  },
  watch: {},
  methods: {
    handleclickseach(){
      this.$router.push({
        path:'productSeach',
        query:{
          searchKey:this.seachInput
        }
      })
    },

    handleClickLogin(){//点击登录
      this.titleFlag = '0'
      this.dialogFormVisible = true
    },
    close(){//子组件穿参 关闭登录弹框
      this.dialogFormVisible =false
    },
    
    hanldeClickRegister(){//点击注册
      this.dialogFormVisible = true
      this.titleFlag = '1'
    },
    getuserInfo(){
      if(this.getCookie("userInfodoor")){
        this.userName = JSON.parse(this.getCookie("userInfodoor")).loginName
      }
    },
    handleClickout(){
      this.Axios({
        method:"post",
        url:Action.SECURITY_W_LOGOUT,
        data:{
          
        }
      }).then(res =>{
          if(res.data.code === '000'){
            setCookie("userInfodoor","");
            setCookie("userType","");
            this.userName = ''
          }else{
              this.$alert(res.data.msg || '系统错误...','错误提示',{
                  cofirmButtonText:'确定',
                  type:'error'
              })
          }
      }).catch(err =>{
              console.log(err)
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
     this.getuserInfo()
    //  this.addFangwenNum()
    });
  },
};
</script>

<style lang="less" scoped>
    
  .headers{
    height:64px;
    display: flex;
    justify-content: space-between;
    background:#f2f5fa;
    align-items: center;
    min-width:1350px;
    // overflow-x: auto;
    .logoNavBox{
      flex:1;
      padding-left:30px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .logoImg{
        width: 105px;
	      height: 26px;
      }
      .navBox{
      width:630px;
        margin-left:33px;
        display: flex;
        a{
          height: 64px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 64px;
          letter-spacing: 0px;
          color: #191a24;
          margin-right:20px;
          cursor: pointer;
        }
        .router-link-exact-active{
          color:#004da2;
          border-bottom: 2px solid #004da2;
        }
      }
    }
    .seachBox{
      margin-right:20px;
      width:320px;
      height:38px;
      background:#ebf1ff;
      border-radius: 19px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .seachName{
        width: 90px;
        height: 38px;
        background-color: #90b3e4;
        color: #ffffff;
        font-size:14px;
        text-align: center;
        line-height:38px;
        border-radius: 19px 0 0 19px;
      }
      .seachInput{
        width:190px;
        height:38px;
        background:#ebf1ff;
        padding-left:10px;
        color:#999999;
        background:none; outline:none; border:none;
      }
      .seachImg{
        width:40px;
        height:38px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        cursor: pointer;
        .seachhome{
          width: 16px;
	        height: 16px;
        }
      }
    }
    .logregbox{
      width:200px;
      height:64px;
      display: flex;
      .login{
        width: 100px;
        height: 64px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        color:#191a24;
        font-size: 14px;
        cursor: pointer;
      }
      .resg{
        width: 100px;
        height: 64px;
        background-color: #2c6eff;
        display: flex;
        justify-content: space-around;
        align-items: center;
        color:#fff;
        font-size: 14px;
        cursor: pointer;
      }
    }
    .userBox{
      padding: 0 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .usernameBox{
        color:#004da2;
        font-weight:900;
        margin-left:20px;
      }
      .logoutBox{
        color:#004da2;
        font-weight:900;
        margin-left:20px;
        cursor: pointer;
      }
    }
  }

</style>






// WEBPACK FOOTER //
// src/components/head/head.vue